module.exports = __webpack_public_path__ + "img/icon-decoration9.048fb320.png";